import React, { useState, useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";
import { Container, Row, Col, Tab } from "react-bootstrap";
import useAuth from "../../../utils/useAuth";
import "./Style.css";

import InputField from './InputField';
import { QRCode } from 'react-qrcode-logo';
import SelectField from './SelectField';
import TextArea from './TextArea';
import ImageUploadField from './ImageUploadField';
import CheckboxField from './CheckboxField';
import ReactJson from 'react-json-view';
import Main from "./main";
import BasicTabs from "./Tabview";


const CatergoryGrid = () => {
  useAuth();

  const [state, setState] = useState({});
  const ref = useRef();

  const handleChange = ({ target }) => {
      setState(prevState => ({ ...prevState, [target.name]: target.value }));
  };

  const handleDownload = () => {
      ref.current?.download();
  };

  const buildEyeRadiusInput = (id) => {
      return (
          <InputField
              name={id}
              type='range'
              handleChange={handleChange}
              min={0}
              max={50}
              hideLabel
              defaultValue={state[id]}
          />
      );
  };

  return (
    <>
      <div id="content-page" className="" >
        <Container>
          <Row>
            <Col lg="12">
              <Tab.Container defaultActiveKey="f1">
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="f1">
                    {/* <Row> */}
                   <BasicTabs/>
                    {/* </Row> */}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default CatergoryGrid;
